/**
 * Lo que está en duro para Constructora 3T, el único cliente del plan. Se quedan
 * acá a propósito: con un solo cliente, sacarlos de `Organization` —que ya tiene
 * `name` y `logo`— es trabajo para un problema que todavía no existe.
 */
export const DEMO_COMPANY_NAME = "Constructora 3T";

export const DEMO_COMPANY_LOGO =
  "https://pub-0dca39eb741341ea977662839c163ab9.r2.dev/logo_3t.png";
